import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NpsCategoryComponent } from './nps-category.component';
import {HighchartsChartModule} from "highcharts-angular";
import {AlertBannerModule} from "../../lib/alert-banner";



@NgModule({
  declarations: [NpsCategoryComponent],
  imports: [
    CommonModule,
    HighchartsChartModule,
    AlertBannerModule.forRoot(),
  ],
  exports: [NpsCategoryComponent]
})
export class NpsCategoryModule { }
